import React from 'react'
import IdeaLogo from '../../assets/images/idealogo.png'
import { Facebook, Instagram, Linkedin } from 'lucide-react'

const FloatingSocialButtons = () => {
  return (
    <div className='fixed top-1/4 right-[5%] flex flex-col  gap-5 z-10'>
        <a href="https://ideassiongroup.com/" className=''>
            <img src={IdeaLogo} alt="" className='bg-white h-8 w-8 p-2 rounded-full hover:bg-[#191991] transition-all ease-in-out duration-300' />
        </a>
        <a href="https://www.linkedin.com/in/imthyaz-sheriff/" className=''>
        <svg className='bg-white h-8 w-8 p-2 rounded-full fill-black stroke-none hover:bg-[#0077b5] hover:fill-white transition-all ease-in-out duration-300' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M100.3 448H7.4V148.9h92.9zM53.8 108.1C24.1 108.1 0 83.5 0 53.8a53.8 53.8 0 0 1 107.6 0c0 29.7-24.1 54.3-53.8 54.3zM447.9 448h-92.7V302.4c0-34.7-.7-79.2-48.3-79.2-48.3 0-55.7 37.7-55.7 76.7V448h-92.8V148.9h89.1v40.8h1.3c12.4-23.5 42.7-48.3 87.9-48.3 94 0 111.3 61.9 111.3 142.3V448z"/></svg>
        </a>
        <a href="https://www.facebook.com/share/15twHF542B/" className=''>
            <Facebook className='bg-white h-8 w-8 p-2 rounded-full fill-black stroke-none hover:bg-[#316ff6] hover:fill-white transition-all ease-in-out duration-300' />
        </a>
        {/* <a href="#" className=''>
        <svg className='bg-white h-8 w-8 p-2 rounded-full fill-black stroke-none hover:bg-[#191991] hover:fill-white transition-all ease-in-out duration-300' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path  d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"/></svg>
        </a> */}
        <a href="https://www.instagram.com/imthyaz.s/?hl=en" className=''>
            <Instagram className=' h-8 w-8 p-2 rounded-full  stroke-black bg-white hover:bg-gradient-to-r hover:from-[#feda75] hover:via-[#fa7e1e] hover:to-[#d62976] hover:stroke-white transition-all ease-in-out duration-300' />
        </a>
    </div>
  )
}

export default FloatingSocialButtons